"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var compatible_1 = require("@ant-design/compatible");
var Header = function (props) {
    return (react_1.default.createElement("div", { className: "component_header" },
        react_1.default.createElement("div", null,
            react_1.default.createElement("span", null, props.iconProps
                ? react_1.default.createElement(compatible_1.Icon, __assign({}, props.iconProps, { className: "header_icon" }))
                : null),
            react_1.default.createElement("span", { className: "component_header_title" }, props.title)),
        react_1.default.createElement("div", { className: "header_right" }, props.action)));
};
exports.default = Header;
